import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=2c782c93&scoped=true&lang=pug&"
import script from "./VideoList.vue?vue&type=script&lang=js&"
export * from "./VideoList.vue?vue&type=script&lang=js&"
import style0 from "./VideoList.vue?vue&type=style&index=0&id=2c782c93&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c782c93",
  null
  
)

export default component.exports